import * as React from 'react';

import { CustomTooltip } from '@cian/ui-kit';

import * as style from './style.css';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

interface IQuestionOnboardingFeatureProps {
  isShown: boolean;
  onClose(): void;
  onShow(): void;
  children: React.ReactElement;
}

export const QuestionOnboardingFeature = ({ isShown, onClose, onShow, children }: IQuestionOnboardingFeatureProps) => {
  const ref = React.useRef<HTMLDivElement>(null);

  const onClick = (event: React.MouseEvent) => {
    event.preventDefault();
  };

  return (
    <>
      <div ref={ref}>{children}</div>
      <div className={style['tooltip']} onClick={onClick}>
        {ref.current && (
          <ActionAfterViewObserver triggerOnce callback={onShow} percentVisible={1}>
            <CustomTooltip
              anchorRef={ref}
              content="Если что-то непонятно, спросите — вам ответит застройщик или один из пользователей Циан"
              header="Теперь можно задать вопрос про ЖК"
              open={isShown}
              placement="right"
              theme="blue"
              maxWidth={400}
              arrow
              closeButton
              onClose={onClose}
              size="S"
              portal={false}
            />
          </ActionAfterViewObserver>
        )}
      </div>
    </>
  );
};
